/* 🤖 this file was generated by svg-to-ts */
export const iconBat: {
  name: 'bat';
  data: string;
} = {
  name: 'bat',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><g clip-path="url(#basicattentiontoken__clip0_292_125)"><path fill="#fff" d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16"/><path fill="#9E1F63" d="m20.85 20.08 6.83 3.91L16.06 3.93v8.17c.05.08 4.79 7.98 4.79 7.98"/><path fill="#662D91" d="M20.85 20.08h-9.62l-6.92 3.94L27.68 24z"/><path fill="#FF5000" d="m22.04 20.75-5.99-9.96V3.94L4.31 24.02l5.76-3.28h11.98zm-9.62-1.34 3.63-6.06 3.64 6.06z"/></g><defs><clipPath id="basicattentiontoken__clip0_292_125"><path fill="#fff" d="M0 0h32v32H0z"/></clipPath></defs></svg>`,
};
